module.exports = __webpack_public_path__ + "img/ypo-login-bg.d46e4419.png";